import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import { EVerificationMethod } from '@/config/payment';

import { FormikPassword } from '@/components/formik/FormikPassword';
import { FormikRadioGroup } from '@/components/formik/FormikRadioGroup';
import { FormikSelect } from '@/components/formik/FormikSelect';
import { FormikText } from '@/components/formik/FormikText';
import { InfoBox } from '@/components/InfoBox';

import type { TAddNewMethodForm } from '@/types/wallet';

import { BANK_ACCOUNT_TYPES, PAYMENT_METHODS, VERIFICATION_METHODS } from './config';
import { addNewStyles as styles } from './PaymentMethod.styles';

export const AddNewMethod = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<TAddNewMethodForm>();

  return (
    <>
      <FormikSelect
        name="data.method"
        label="stationSetup.connectBank.paymentMethod"
        options={PAYMENT_METHODS}
      />

      <Box sx={styles.section}>
        <Typography variant="h6" sx={styles.title}>
          {t('stationSetup.connectBank.chooseVerification')}
        </Typography>

        <FormikRadioGroup
          variant="fullWidth"
          name="data.verification"
          options={VERIFICATION_METHODS}
          renderOption={({ label, details }) => (
            <>
              <Typography marginBottom={0.5} fontWeight={500}>
                {t(label)}
              </Typography>
              <Typography variant="body2">{t(details)}</Typography>
            </>
          )}
          sx={{ gap: 4 }}
        />
      </Box>

      {values.data.verification === EVerificationMethod.MANUAL && (
        <Box sx={styles.section}>
          <Typography variant="h6" sx={styles.title}>
            {t('stationSetup.connectBank.bankInfo')}
          </Typography>

          <FormikText
            name="data.bankAccount.name"
            label="stationSetup.connectBank.accountNickname"
          />

          <FormikSelect
            name="data.bankAccount.bankAccountType"
            label="stationSetup.connectBank.accountType"
            options={BANK_ACCOUNT_TYPES}
          />

          <FormikPassword
            name="data.bankAccount.routingNumber"
            label="stationSetup.connectBank.routingNumber"
          />

          <FormikPassword
            name="data.bankAccount.accountNumber"
            label="stationSetup.connectBank.accountNumber"
          />

          <InfoBox>{t('stationSetup.connectBank.verificationInfo')}</InfoBox>
        </Box>
      )}
    </>
  );
};
